export default class AuthService 
{
    constructor(http) {
        this.http = http        
    }

    async getAuthorizationUrl() {        
        return await this.http.get('/redirect-url')        
    }

    async getUserData() {
        return await this.http.get('/user-data')   
    }

    async logout() {
        return await this.http.get('/logout')
    }
}